// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"1da2f6c0","453":"c02bb138","957":"55905929"}[chunkId] + ".chunk.js";
};